import axios from "axios";

// create an axios instance
const service = axios.create({
  // baseURL: "http://test.bom.ai:8094/api/v1", // url = base url + request url
  baseURL: "https://api.bom.ai/api/v1", // url = base url + request url
  // baseURL: "http://192.168.1.10:8004/api/v1",
  // withCredentials: true,
  timeout: 5000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // config.withCredentials = true
    // config.headers['Authorization'] = getToken()
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    return response.data.Result.Data;
  },
  error => {
    return Promise.reject(error.response.data);
  }
);

export default service;
